import {EventEmitter, Injectable, Output} from '@angular/core';
import {Observable} from "rxjs/Observable";
import {UserService} from "./user.service";

@Injectable()
export class ReportService {

    constructor(private userService: UserService) {
    }
    @Output() tradeprice: EventEmitter<boolean> = new EventEmitter();
    toggleTradeChangePrice(data){
        this.tradeprice.emit(data);
    }

    public getUserReferals(): Observable<any> {
        return this.userService.userequest('get', 'getreferralhistory',null,{});
    }

    public getBonustrans(filter): Observable<any> {
        return this.userService.userequest('post', 'getreferralbonustrans',filter);
    }

    public getCollateralDeposit(filter): Observable<any> {
        return this.userService.userequest('post', 'getCollateralDeposit',filter);
    }
    
    public editCollateralDeposit(data): Observable<any> {
        return this.userService.userequest('post', 'editCollateralDeposit',data);
    }

    public processCollateralDeposit(data): Observable<any> {
        return this.userService.userequest('post', 'processCollateralDeposit',data);
    }

    public editAdminTradeMaster(data): Observable<any> {
        return this.userService.userequest('post', 'editAdminTradeMaster',data);
    }

    public editIndusindBankTransaction(data): Observable<any> {
        return this.userService.userequest('post', 'edit-indusind-bank-transaction',data);
    }
}




// WEBPACK FOOTER //
// ./src/app/services/report.service.ts